"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _Header = require("./Header.styles");

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

var _elements = require("../../styles/elements");

var Header = function Header(_ref) {
  var className = _ref.className,
      tabsData = _ref.tabsData,
      tabType = _ref.tabType,
      children = _ref.children,
      onTabChange = _ref.onTabChange,
      activeKey = _ref.activeKey,
      onGoBack = _ref.onGoBack;
  return (0, _jsxRuntime.jsxs)("header", {
    css: _Header.styles.base,
    className: (0, _clsx["default"])('grui', className),
    children: [typeof onGoBack === 'function' && (0, _jsxRuntime.jsx)("div", {
      css: _Header.styles.backBtnWrapper,
      children: (0, _jsxRuntime.jsx)("button", {
        type: "button",
        css: _elements.button.styles.preflight,
        "aria-label": "Go back",
        onClick: onGoBack,
        children: (0, _jsxRuntime.jsx)("span", {})
      })
    }), (0, _jsxRuntime.jsx)("div", {
      css: _Header.styles["".concat(tabType, "Tab")],
      children: (0, _jsxRuntime.jsx)(_Tabs["default"], {
        tabs: tabsData,
        onChange: onTabChange,
        type: tabType,
        activeKey: activeKey
      })
    }), (0, _jsxRuntime.jsx)("div", {
      css: _Header.styles.wrapper,
      children: children
    })]
  });
};

Header.propTypes = {
  className: _propTypes.string,

  /**
   * Data for tabs
   */
  tabsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string.isRequired,
    tabName: _propTypes.string.isRequired
  })).isRequired,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * Props for Tabs component
   */
  onTabChange: _propTypes.func.isRequired,
  tabType: (0, _propTypes.oneOf)(['big', 'small']),
  activeKey: _propTypes.string,

  /**
   * Callback for handling go back:
   * if the function is passed, will show go back button
   */
  onGoBack: _propTypes.func
};
Header.defaultProps = {
  className: undefined,
  children: undefined,
  tabType: 'big',
  activeKey: undefined,
  onGoBack: undefined
};
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map